/* DK infinite scroll — collection pages.
   Reads the next-page URL from .dk-inf (rendered by snippets/pagination.liquid), fetches only the
   product-grid section, appends the cards and swaps in the new pagination/marker.
   Page links stay in the HTML (SEO + fallback) and are hidden while this script is active. */
(function () {
  if (window.__dkInfinite) return;
  window.__dkInfinite = true;
  if (!('IntersectionObserver' in window)) return;

  var busy = false;
  var io = null;
  var ROOT_MARGIN = 900; // px before the end of the grid to start loading

  function container() { return document.getElementById('ProductGridContainer'); }
  function marker() { var c = container(); return c && c.querySelector('.dk-inf[data-next-url]'); }

  function setup() {
    if (io) { io.disconnect(); io = null; }
    var m = marker();
    var root = document.documentElement;
    if (!m || !m.dataset.nextUrl) { root.classList.remove('dk-inf-on'); return; }
    root.classList.add('dk-inf-on');
    io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      // Also load when the user jumped past the marker (e.g. straight to the footer)
      if (e && (e.isIntersecting || e.boundingClientRect.top < 0)) load();
    }, { rootMargin: '0px 0px ' + ROOT_MARGIN + 'px 0px' });
    io.observe(m);
  }

  function nearEnd(el) {
    return el && el.getBoundingClientRect().top < window.innerHeight + ROOT_MARGIN;
  }

  // Backup for browsers that delay observer callbacks: throttled scroll check
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    setTimeout(function () {
      ticking = false;
      var m = marker();
      if (m && nearEnd(m)) load();
    }, 250);
  }, { passive: true });

  function load() {
    var m = marker();
    var grid = document.getElementById('product-grid');
    if (busy || !m || !m.dataset.nextUrl || !grid) return;
    busy = true;
    m.classList.add('is-loading');

    var url = new URL(m.dataset.nextUrl, window.location.origin);
    url.searchParams.set('section_id', grid.dataset.id);

    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('product-grid');
        var row = grid.querySelector('[data-product-column]');
        if (!newGrid || !row) throw new Error('grid not found');

        var cols = newGrid.querySelectorAll('[data-product-column] > *');
        var frag = document.createDocumentFragment();
        for (var i = 0; i < cols.length; i++) frag.appendChild(document.importNode(cols[i], true));
        row.appendChild(frag);

        // Swap pagination + marker for the ones from the next page
        var oldPag = grid.querySelector('.pagination-wrapper');
        var newPag = newGrid.querySelector('.pagination-wrapper');
        if (oldPag && newPag) oldPag.replaceWith(document.importNode(newPag, true));
        else if (oldPag) oldPag.remove();

        var newMarker = newGrid.querySelector('.dk-inf[data-next-url]');
        if (newMarker) m.replaceWith(document.importNode(newMarker, true));
        else m.remove();

        document.dispatchEvent(new CustomEvent('dk:products-appended', { detail: { count: cols.length } }));
      })
      .catch(function (err) {
        console.warn('[dk-infinite]', err);
        // Fall back to normal page links
        var mm = marker();
        if (mm) mm.removeAttribute('data-next-url');
        document.documentElement.classList.remove('dk-inf-on');
      })
      .then(function () {
        busy = false;
        setup();
        // Short pages: keep loading while the marker is still near the viewport
        var next = marker();
        if (next && nearEnd(next)) load();
      });
  }

  function init() {
    setup();
    // Filters / sorting replace #ProductGridContainer's content — re-attach after each render
    var c = container();
    if (c) new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].target === c) { setup(); break; }
      }
    }).observe(c, { childList: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
